import type { ReactNode } from 'react';

export const symbol_network_wifi: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M130-552q75-60 164-94t186-34q97 0 186 34t164 94l42-42q-85-66-184.5-106T480-740q-108 0-207.5 40T88-594l42 42Zm308 390L47-553q-9-9-13.5-20.5T29-596q0-13 5.5-25T51-642q91-76 200.5-117T480-800q119 0 228.5 41T909-642q11 9 16.5 21t5.5 25q0 11-4.5 22.5T913-553L522-162q-9 9-20 13t-22 4q-11 0-22-4t-20-13Z"
		/>
	</svg>
);
